import { Icon, Text, type TradeSettleStatusEnum } from '@talos/kyoko';
import { memo } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getLPTradeStatusMapping } from '../utils/lpTradeStatusMapping';

interface LPTradeStatusRendererProps {
  theme: DefaultTheme;
  status: TradeSettleStatusEnum;
}

export const LPTradeStatusRenderer = memo(({ theme, status }: LPTradeStatusRendererProps) => {
  const statusMapping = getLPTradeStatusMapping(status, theme);

  // If no status mapping, just show the raw status with empty space for icon
  if (!statusMapping) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {statusMapping.icon ? (
        <Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />
      ) : (
        <span style={{ width: '12px', display: 'inline-block' }} />
      )}
      <Text>{statusMapping.label}</Text>
    </div>
  );
});

LPTradeStatusRenderer.displayName = 'LPTradeStatusRenderer';
